import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import store from '@/store'

export const useCommunityqPublishingStore = defineStore('communityqPublishing', {
  state: () => ({
    storyIds: [],
    when: 'dont',
    pubTime: new Date()
  }),

  actions: {
    initializeForModal() {
      // Reset to default values when opening modal
      this.when = 'dont'
      this.pubTime = new Date()
    },

    async submit() {
      // Set pubTime to null when user chooses "Do not publish"
      if (this.when === 'dont') {
        this.pubTime = null
      }

      return httpClient.patch('/api/internal/communityq_stories/batch_update', {
        community_q_stories: {
          ids: this.storyIds,
          web_publish_on: this.pubTime
        }
      }).then(({ data }) => {
        store.dispatch('messages/addNotice', data.message)
        this.$reset()
        return data
      }).catch(err => {
        store.dispatch('messages/addError', err)
      })
    }
  }
})
